export default __webpack_public_path__ + "static/media/Show-documentation.67d54277.md";